import { createAction } from '@reduxjs/toolkit'
import { TDialog } from 'domain/types'

export const setDialogState = createAction<TDialog>('dialog/setDialogState')
